/**
 * Automation Module Views
 */

export { default as AutomationView } from './AutomationView';
